import Vue from 'vue'
import App from './App.vue'
import router from './router'
import VueMeta from 'vue-meta';
import 'bulma/css/bulma.css';
import 'lato-font/css/lato-font.css'
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
//import { faPhone  } from "@fortawesome/faAddressBook";
import { far } from '@fortawesome/free-regular-svg-icons';
import { fab } from '@fortawesome/free-brands-svg-icons';

import '@fortawesome/fontawesome-free/css/all.css'
import '@fortawesome/fontawesome-free/js/all.js'

import VModal from 'vue-js-modal'
import i18n from './i18n'
import VueMask from 'v-mask'

//const { API } = require( './api/member-api' + '?v=' + process.env.VUE_APP_VERSION )

Vue.use(VueMask)
Vue.use(VModal, { dynamic: true, injectModalsContainer: true })

Vue.prototype.$generalMessage = function(mb, message, callBack) 
{
  /* if(SUPPORT.isSupported())
  { */
    var clientWidth = document.documentElement.clientWidth;
    var theWidth = (clientWidth > 1023) ? 400 : 300;
    var theHeight = (clientWidth < 600) ? 250 : 200;

    // DISPLAY THE STD MESSAGE INFORMATION BOX
    this.$modal.show(mb, {
      text: message,
      func: callBack,
    }, 
    {
      draggable: true,
      width: theWidth, //400, // '40%',
      height: theHeight, //200,
      clickToClose: false,
      styles: {"border-radius":"15px"}
    });
  /*}
   else{
    var title = "eHealth Engagement, LLC.\n\nInformation: ";
    alert(title + message);
  } */
};

// MAKE THE API AVAILABLE GLOBALY
window.sessionKey = '';

library.add(
  fas,
  far,
  fab
);

Vue.component("font-awesome-icon", FontAwesomeIcon);
Vue.use(VueMeta);
// Importing the global css file
// import "@/assets/styles/global.css"

Vue.config.productionTip = false

/*
new Vue({
  created() {
   window.addEventListener('beforeunload', this.addLogoffEvent);
   window.addEventListener('onunload', this.addLogoffEvent);
  },
 
  methods:
  {
    addLogoffEvent()
    {
      //e.preventDefault();
      //e.returnValue = '';
      if(window.sessionKey != '')
      { 
        API.logoff(window.sessionKey);
        window.sessionKey = ''
      }
    }
  },

  router,
  i18n,
  render: h => h(App)
}).$mount('#app');*/

fetch(process.env.BASE_URL + "config.json") // LOAD CONFIG FILE FROM PUBLIC
  .then((response) => response.json())
  .then((config) => {
       Vue.prototype.$config = config

    new Vue({
      /* created() {
      window.addEventListener('beforeunload', this.addLogoffEvent);
      window.addEventListener('onunload', this.addLogoffEvent);
      },
      methods:
      {
        addLogoffEvent()
        {
          if(window.sessionKey != '')
          { 
            API.logoff(window.sessionKey);
            window.sessionKey = ''
          }
        }
      }, */
      router,
      i18n,
      render: h => h(App)
    }).$mount('#app');
  })

  window.Vue = Vue;

/* 
MAYBE SOMEDAY I WILL HAVE TIME TO FIGURE OUT HOW
TO GET THIS WORKING 
Vue.prototype.$ShowInformation = function(message) 
{
  var ComponentClass = Vue.extend(messageBox)
  var m = new ComponentClass()
  
  // DISPLAY THE STD MESSAGE INFORMATION BOX
  this.$modal.show(m, {
    text: message
  }, 
  {
    draggable: true,
    width:400,
    height: 200,
    clickToClose: false,
    styles: {"border-radius":"15px"}
  })
}; */